import * as React from 'react';
import { useMemo } from 'react';
import { CheckoutSteps } from '../../MobileStepbar/types';
import { ServiceSummary } from '../../features/service-summary';
import CartItemOptionAdapter from '../CartItemOptionAdapter/CartItemOptionAdapter';
import ServiceSummaryDivider from '../../ServiceSummary/components/ServiceSummaryDivider/ServiceSummaryDivider';
import CartServiceSummary from '../../ServiceSummary';
const Misc = ({ services, onServiceDelete, renderService }) => {
    const gdsServices = useMemo(() => {
        var _a, _b;
        return new Map(((_b = (_a = services.gdsServices) === null || _a === void 0 ? void 0 : _a.services) === null || _b === void 0 ? void 0 : _b.map(service => [service.id, service])) || []);
    }, [services === null || services === void 0 ? void 0 : services.gdsServices]);
    return (React.createElement(ServiceSummary, { serviceType: "Misc", onDelete: onServiceDelete, renderSummary: groups => {
            var _a;
            const miscGroupsPerSubType = new Map();
            for (const group of groups) {
                for (const item of group.items) {
                    const miscService = gdsServices.get(item.id);
                    if (!miscService) {
                        continue;
                    }
                    const rfisc = miscService.rfisc;
                    miscGroupsPerSubType.set(rfisc, [
                        ...((_a = miscGroupsPerSubType.get(rfisc)) !== null && _a !== void 0 ? _a : []),
                        Object.assign(Object.assign({}, group), { items: group.items.filter(item => !item.rfisc || item.rfisc === rfisc) })
                    ]);
                }
            }
            return (React.createElement(React.Fragment, null, [...miscGroupsPerSubType].map(([subType, groups]) => {
                var _a, _b, _c, _d;
                const header = (_c = (_b = (_a = groups[0]) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.name;
                const cartGroup = { header };
                const content = (React.createElement(ServiceSummaryDivider, null, groups.map((group, index) => (React.createElement(CartItemOptionAdapter, { key: `${subType}-${index}`, option: group })))));
                return ((_d = renderService === null || renderService === void 0 ? void 0 : renderService(CheckoutSteps.Extras, cartGroup, content)) !== null && _d !== void 0 ? _d : (React.createElement(CartServiceSummary, { key: subType, group: cartGroup }, content)));
            })));
        } }));
};
export default Misc;
